import { create } from 'zustand';
import type { EngagementSnapshot } from '@/types/emotion';

type SessionState = {
  sessionId: string | null;
  roomUrl: string | null;
  role: 'student' | 'instructor' | null;
  snapshots: EngagementSnapshot[];
  setSession: (payload: { sessionId: string; roomUrl: string; role: 'student' | 'instructor' }) => void;
  addSnapshot: (snapshot: EngagementSnapshot) => void;
  reset: () => void;
};

export const useSessionStore = create<SessionState>((set) => ({
  sessionId: null,
  roomUrl: null,
  role: null,
  snapshots: [],
  setSession: (payload) =>
    set({
      sessionId: payload.sessionId,
      roomUrl: payload.roomUrl,
      role: payload.role
    }),
  addSnapshot: (snapshot) =>
    set((state) => ({
      snapshots: [...state.snapshots.filter((s) => s.studentId !== snapshot.studentId || s.timestamp !== snapshot.timestamp), snapshot]
    })),
  reset: () => set({ sessionId: null, roomUrl: null, role: null, snapshots: [] })
}));

